import type { HelpCategory, Profile } from '../types/Help'
import { CategoryList } from '../types/localization/HelpCopy'
import { HELP_CATEGORIES } from '../constants/Help'

const isCategoryAccessibleByProfile = (category: HelpCategory, profile: Profile): boolean => {
  if (category.guid === 'general' || category.guid === 'insights') return true
  if (!category.flags) return false
  return category.flags.every((flag) => profile[flag as keyof Profile])
}

export const HelpUtil = (profile: Profile, categoryList: CategoryList): HelpCategory[] => {
  const accessibleCategories: HelpCategory[] = []

  for (const el of HELP_CATEGORIES) {
    const category = categoryList[el.guid as keyof CategoryList]
    if (!category) continue

    const updatedCategory = {
      ...el,
      title: category.label,
      topics: el.topics.map(({ topicKey }, index) => ({
        topicKey,
        label: category.topics[index],
      })),
    }
    if (isCategoryAccessibleByProfile(updatedCategory, profile))
      accessibleCategories.push(updatedCategory)
  }

  return accessibleCategories
}
